import { render, staticRenderFns } from "./ViewIosProfiles.vue?vue&type=template&id=7fdd6ead"
import script from "./ViewIosProfiles.vue?vue&type=script&lang=js"
export * from "./ViewIosProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports